const ChatTextInput = ({
  inputRef,
  value,
  onChange,
  onSend,
  disabled,
  placeholder,
}) => {
  return (
    <div className='chat-inputbar'>
      <div className='chat-input-inner'>
        <div className='chat-input-box'>
          <textarea
            ref={inputRef}
            rows={1}
            value={value}
            onChange={onChange}
            onKeyDown={(event) => {
              if (event.key === 'Enter' && !event.shiftKey) {
                event.preventDefault()
                onSend()
              }
            }}
            placeholder={placeholder}
            disabled={disabled}
            className='chat-textarea'
          />

          <button
            type='button'
            onClick={onSend}
            disabled={!value.trim() || disabled}
            className='send-btn'
            aria-label='Send message'
          >
            <svg
              width='13'
              height='13'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <line x1='22' y1='2' x2='11' y2='13' />
              <polygon points='22 2 15 22 11 13 2 9 22 2' />
            </svg>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ChatTextInput